import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b64555c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 data-v-b64555c4>Conversion Matrix</h1><div class=\"row\" data-v-b64555c4><div class=\"col-2\" data-v-b64555c4></div><div class=\"col-2\" data-v-b64555c4><i class=\"fas fa-square onedaycutoff\" data-v-b64555c4></i> Yes if on booking day</div><div class=\"col-2\" data-v-b64555c4><i class=\"fas fa-square morethanonedaycutoff\" data-v-b64555c4></i> Yes if after the booking day</div><div class=\"col-2\" data-v-b64555c4><i class=\"fas fa-square twodaycutoff\" data-v-b64555c4></i> Yes if booking day or next day</div><div class=\"col-2\" data-v-b64555c4><i class=\"fas fa-square morethantwodaycutoff\" data-v-b64555c4></i> Yes if after 2 days of booking</div><div class=\"col-2\" data-v-b64555c4><i class=\"fas fa-square statusseen\" data-v-b64555c4></i> Yes if status seen</div></div>", 2)
const _hoisted_4 = { class: "card-body p-0 matrix-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"z-index":"10"} }, null, -1))
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle fa-2x unselected" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_12 = { class: "container-fluid" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-auto" }, null, -1))
const _hoisted_14 = { class: "ml-auto text-light" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))

import { inject, ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';

import conversionmatrix from "../assets/json/conversionmatrix.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversionMatrix',
  setup(__props) {

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');
const getSysParam = (key: string) => store.dispatch('app/getSysParam', key);
const updateSysParam = (key: string, value: string) => store.dispatch('app/updateSysParam', {key, value});

let selected = ref({});
let conversionkeys: string[] = [];
let onedaycutoff = ref({});
let morethanonedaycutoff = ref({});
let twodaycutoff = ref({});
let morethantwodaycutoff = ref({});
let statusseen = ref({});

onMounted(async () => {
  for(let k = 0; k < conversionmatrix.rulegroups.length; k++) {
    let rg: string = conversionmatrix.rulegroups[k].name;
    selected.value[rg] = {};
    onedaycutoff.value[rg] = {};
    morethanonedaycutoff.value[rg] = {};
    twodaycutoff.value[rg] = {};
    morethantwodaycutoff.value[rg] = {};
    statusseen.value[rg] = {};
    for(let i = 0; i < conversionmatrix.sections.length; i++) {
      let s: any = conversionmatrix.sections[i];
      for(let j = 0; j < s.fieldlist.length; j++) {
        let field = s.fieldlist[j];
        selected.value[rg][`${s.name}/${field}`] = false;
        onedaycutoff.value[rg][`${s.name}/${field}`] = false;
        morethanonedaycutoff.value[rg][`${s.name}/${field}`] = false;
        twodaycutoff.value[rg][`${s.name}/${field}`] = false;
        morethantwodaycutoff.value[rg][`${s.name}/${field}`] = false;
        statusseen.value[rg][`${s.name}/${field}`] = false;
      }
    }
  }
  const matrixvalue = await getSysParam('conversionmatrix');
  if(conversionkeys) {
    conversionkeys = matrixvalue.split(',');
    for(let i = 0; i < conversionkeys.length; i++) {
      const rgkey = conversionkeys[i].substring(0,1);
      const fldkey = conversionkeys[i].substring(1);
      const rg: string  = keytorulegroup(rgkey);
      const fld: string = keytofield(Number(fldkey));
      if(rg && fld) {
        selected.value[`${rg}`][`${fld}`] = true;
      }
    }
  }

  for(let k = 0; k < conversionmatrix.onedaycutoff.length; k++) {
    let pair: string = conversionmatrix.onedaycutoff[k];
    const rgkey = pair.substring(0,1);
    const fldkey = pair.substring(1);
    const rg: string  = keytorulegroup(rgkey);
    const fld: string = keytofield(Number(fldkey));
    onedaycutoff.value[`${rg}`][`${fld}`] = true;
  }
  for(let k = 0; k < conversionmatrix.morethanonedaycutoff.length; k++) {
    let pair: string = conversionmatrix.morethanonedaycutoff[k];
    const rgkey = pair.substring(0,1);
    const fldkey = pair.substring(1);
    const rg: string  = keytorulegroup(rgkey);
    const fld: string = keytofield(Number(fldkey));
    morethanonedaycutoff.value[`${rg}`][`${fld}`] = true;
  }
  for(let k = 0; k < conversionmatrix.twodaycutoff.length; k++) {
    let pair: string = conversionmatrix.twodaycutoff[k];
    const rgkey = pair.substring(0,1);
    const fldkey = pair.substring(1);
    const rg: string  = keytorulegroup(rgkey);
    const fld: string = keytofield(Number(fldkey));
    twodaycutoff.value[`${rg}`][`${fld}`] = true;
  }
  for(let k = 0; k < conversionmatrix.morethantwodaycutoff.length; k++) {
    let pair: string = conversionmatrix.morethantwodaycutoff[k];
    const rgkey = pair.substring(0,1);
    const fldkey = pair.substring(1);
    const rg: string  = keytorulegroup(rgkey);
    const fld: string = keytofield(Number(fldkey));
    morethantwodaycutoff.value[`${rg}`][`${fld}`] = true;
  }
  for(let k = 0; k < conversionmatrix.statusseen.length; k++) {
    let pair: string = conversionmatrix.statusseen[k];
    const rgkey = pair.substring(0,1);
    const fldkey = pair.substring(1);
    const rg: string  = keytorulegroup(rgkey);
    const fld: string = keytofield(Number(fldkey));
    statusseen.value[`${rg}`][`${fld}`] = true;
  }
});

const fieldnames = computed(()=> {
  let list: any[] = [];
  conversionmatrix.sections.forEach((s: any) => {
    list.push({name: s.name,header: true});
    s.fieldlist.forEach((f: any) => {
      list.push({name:f, header: false});
    })
  });
  return list;
})

const select = (rulegroup: string, sectionname: string, fieldname: string) => {
  selected.value[rulegroup][`${sectionname}/${fieldname}`] = true;
  const rgkey = rulegrouptokey(rulegroup);
  const fldkey = fieldtokey(sectionname, fieldname);
  conversionkeys.push(`${rgkey}${fldkey}`);
}
const unselect = (rulegroup: string, sectionname: string, fieldname: string) => {
  selected.value[rulegroup][`${sectionname}/${fieldname}`] = false;
  const rgkey = rulegrouptokey(rulegroup);
  const fldkey = fieldtokey(sectionname, fieldname);
  const index = conversionkeys.findIndex((k: string) => k === `${rgkey}${fldkey}`);
  if(index >= 0) conversionkeys.splice(index, 1);
}

const alpha = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
const rulegrouptokey = (rulegroup: string) => {
  const index = conversionmatrix.rulegroups.findIndex((rg: any) => rg.name === rulegroup);
  return alpha[index];
}
const keytorulegroup = (key: string) => {
  let rg = '';
  const index = alpha.findIndex((a) => a === key);
  if(index >= 0) {
    rg = conversionmatrix.rulegroups[index].name;
  }
  return rg;
}

const fieldtokey = (sectionname: string, fieldname: string) => {
  let index = -1;
  for(let i = 0; i < conversionmatrix.sections.length; i++) {
    let s: any = conversionmatrix.sections[i];
    for(let j = 0; j < s.fieldlist.length; j++) {
      let field = s.fieldlist[j];
      index++;
      if(s.name === sectionname && field === fieldname) return index;
    }
  }
  return index;
}

const keytofield = (key: number) => {
  let val = '';
  let index = -1;
  for(let i = 0; i < conversionmatrix.sections.length; i++) {
    let s: any = conversionmatrix.sections[i];
    for(let j = 0; j < s.fieldlist.length; j++) {
      let field = s.fieldlist[j];
      index++;
      if(index >= key) return `${s.name}/${field}`;
    }
  }
  return val;
}

const save = async () => {
  await updateSysParam('conversionmatrix', conversionkeys.join(','))
  .then(() => toasted.success("Conversion matrix updated"))
    .catch((err: any) => actProperty.displayError(err));
} 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversionmatrix).rulegroups, (group, $groupindex) => {
              return (_openBlock(), _createElementBlock("th", {
                key: $groupindex,
                class: "rotate"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(group.name), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversionmatrix).sections, (section, $sectionindex) => {
          return (_openBlock(), _createElementBlock("tbody", { key: $sectionindex }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(section.name), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fieldlist, (field, $fieldindex) => {
              return (_openBlock(), _createElementBlock("tr", { key: $fieldindex }, [
                _createElementVNode("td", null, _toDisplayString(field), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversionmatrix).rulegroups, (rulegroup, $groupindex) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "templatecell",
                    key: $groupindex
                  }, [
                    _createElementVNode("div", null, [
                      (_unref(selected)[rulegroup.name] && _unref(selected)[rulegroup.name][`${section.name}/${field}`])
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: ($event: any) => (unselect(rulegroup.name, section.name, field))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["far fa-check-circle fa-2x selected", {'onedaycutoff': _unref(onedaycutoff)[rulegroup.name][`${section.name}/${field}`], 'morethanonedaycutoff': _unref(morethanonedaycutoff)[rulegroup.name][`${section.name}/${field}`], 'twodaycutoff': _unref(twodaycutoff)[rulegroup.name][`${section.name}/${field}`], 'morethantwodaycutoff': _unref(morethantwodaycutoff)[rulegroup.name][`${section.name}/${field}`],  'statusseen': _unref(statusseen)[rulegroup.name][`${section.name}/${field}`]}])
                            }, null, 2)
                          ], 8, _hoisted_7))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            onClick: ($event: any) => (select(rulegroup.name, section.name, field))
                          }, _hoisted_10, 8, _hoisted_8))
                    ])
                  ]))
                }), 128))
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("nav", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (save()), ["prevent"]))
          }, [
            _hoisted_15,
            _createTextVNode(" Save ")
          ])
        ])
      ])
    ])
  ]))
}
}

})